
























































import { defineComponent, reactive, computed } from '@vue/composition-api';
import { usePageBase, useComponentBase } from '../../base';
import { ButtonProgress } from '../../components/button-progress';
import { getStore } from '../../store';
import { useRouter } from '../../router';

const componentName = 'SectionEdit';

export default defineComponent({
    props: {},
    name: componentName,

    setup(props, context) {
        const store = getStore(), { router, route } = useRouter();
        const pageBase = usePageBase();
        const componentBase = useComponentBase();

        const state = reactive({
            loaded: false,
            saveProgress: false,
            appVersionData: null,
            section: null
        });

        const onCreated = () => {

            componentBase.setLoading(true);

            state.appVersionData = store.state.appVersionSummary;
            state.section = state.appVersionData.sections && state.appVersionData.sections.find(x => x.id == route.value.params.sectionId)
            pageBase.setNavigation((nav) => {
                nav.push({ title: 'Apps', routerTo: { name: 'apps' }});
                nav.push({ title: `${state.appVersionData.name} ${state.appVersionData.platform}`, routerTo: { name: 'app-versions' }});
                nav.push(
                    {
                        title: `Version ${state.appVersionData.version} (Build ${state.appVersionData.build}) - Settings`,
                        routerTo: { name: 'app-settings' },
                        extended: true
                    }
                );
                nav.push({ title: 'Section' });
            });

            state.loaded = true;

            componentBase.setLoading(false);
        }

        const updateData = async () => {
            state.appVersionData = await store.dispatch(
                'getAppVersionSummary',
                { versionId: route.value.params.versionId }
            );
            state.section = state.appVersionData.sections && state.appVersionData.sections.find(x => x.id == route.value.params.sectionId)
        }

        const onImageUpload = async (screen : any, data: { file: File, userdata: any }) => {
            let res = await store.dispatch('media/uploadImage', data);
            if (res) {
                screen.imageId = res.image.id;
            }
        }

        const onImageRemove = (screen : any) => screen.imageId = null;

        const getImagePath = (imageId : number) => {
            if (imageId) {
                return `/images/${imageId}`;
            }
        }

        const makeGetImagePath = (sc: any) => {
            return () => { return getImagePath(sc.imageId);}
        }

        const onSave = async () => {
            state.saveProgress = true;

            let res = await store.dispatch('updateAppSection', { section: state.section });

            state.saveProgress = false;
            if (res) {
                store.commit('setUISnackbar', { type: 'success', message: 'Section successfully saved.' });
                router.push({ name: 'app-settings' });
            }
            else {
                store.commit('setUISnackbar', { type: 'error', message: 'Error while saving data to the server. Try again.' });
            }
        }

        onCreated();

        return {
            state,
            updateData,
            onImageUpload,
            onImageRemove,
            getImagePath,
            makeGetImagePath,
            onSave
        }
    },

    components: { ButtonProgress }
})

